import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { dashboardRouteWithSlash } from '../../../route-constants';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {
  errorCode = 404;

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => this.errorCode = params.id || this.errorCode);
  }

  navigateToDashboard() {
    this.router.navigate([dashboardRouteWithSlash]);
  }

}
